import { styled, useTheme } from "@mui/material/styles";
import ThumbnailImageBox from "designSystem/components/box/ThumbnailImageBox";
import { black, grey, white } from "designSystem/styles/color";
import { Box } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import useResizeObserver from "use-resize-observer";
import LBPagination from "./LBPagination";
import {
	useLightboxStore
} from "./LightboxStore";

const ThumbnailBox = styled(Box)(({ theme }) => ({
	alignItems: "center",
	backgroundColor: black[50],
	display: "flex",
	flexWrap: "nowrap",
	minHeight: 128,
	overflow: "hidden",
	paddingBottom: theme.spacing(3),
	paddingTop: theme.spacing(3),
	position: "relative",
	width: "100%",
}));

const Thumbnail = styled(ThumbnailImageBox)(({ theme }) => ({
	backgroundColor: white[50],
	borderRadius: 2,
	flexShrink: 0,
	height: 100,
	marginRight: theme.spacing(3),
	width: 100,
}));

export const LBThumbnail: FunctionComponent = observer(function LBThumbnail() {
	const {
		firstImageOnNextPage,
		selectImage,
		imagesOnPage,
		imagesPerPage,
		index,
		totalPages,
		setPage,
		setImagesPerPage,
	} = useLightboxStore();

	const theme = useTheme();

	// use resize observer to update imagesPerPage from store
	const { ref } = useResizeObserver<HTMLDivElement>({
		onResize: ({ width }) => setImagesPerPage(width),
	});

	return (
		<ThumbnailBox
			height={128}
			ref={ref}
			sx={{
				justifyContent: totalPages > 1 ? "flex-start" : "center",
			}}
		>
			<LBPagination
				count={totalPages}
				updateViewablePage={setPage}
			>
				{imagesPerPage > 0 && imagesOnPage.map((image, i) => (
					<Thumbnail
						hideIcon={false}
						image={image.data.thumbnailSrc}
						isTurntable={image.data.isTurntable}
						key={image.index}
						onClick={() => selectImage(image.index)}
						paddedImage={false}
						sx={{
							border: (image.index) == index ? `2px solid ${theme.palette.FocusPrimary}` : `1px solid ${grey[400]}`,
							opacity: (image.index) == index ? 1 : 0.5,
						}}
					/>
				))}
				{/* Display a placeholder for the first image on the next page if there is a next page*/}
				{firstImageOnNextPage && (
					<Thumbnail
						hideIcon={false}
						image={firstImageOnNextPage?.data.thumbnailSrc}
						isTurntable={false}
						paddedImage={false}
						sx={{
							border: `1px solid ${grey[400]}`,
							opacity: 0.2,
						}}
					/>
				)}
			</LBPagination>
		</ThumbnailBox>
	);
});

export default LBThumbnail;